import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatSidenavModule, MatCardModule } from '@angular/material';

import { TableModule } from 'primeng/table';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { AccordionModule } from 'primeng/components/accordion/accordion';
import { DataGridModule } from 'primeng/components/datagrid/datagrid';
import { PanelModule } from 'primeng/components/panel/panel';
import { ButtonModule } from 'primeng/components/button/button';
import { TooltipModule } from 'primeng/components/tooltip/tooltip';
import { DropdownModule } from 'primeng/components/dropdown/dropdown';
import { MultiSelectModule } from 'primeng/components/multiselect/multiselect';
import { DataTableModule } from 'primeng/components/datatable/datatable';
import { CalendarModule } from 'primeng/components/calendar/calendar';
import { CheckboxModule } from 'primeng/components/checkbox/checkbox';
import { DialogModule } from 'primeng/components/dialog/dialog';
import { InputMaskModule } from 'primeng/components/inputmask/inputmask';
import { GrowlModule } from 'primeng/components/growl/growl';
import { ConfirmDialogModule } from 'primeng/components/confirmdialog/confirmdialog';
import { InputTextModule } from 'primeng/components/inputtext/inputtext';
import { SelectButtonModule } from 'primeng/components/selectbutton/selectbutton';
import { MessagesModule } from 'primeng/components/messages/messages';
import { SpinnerModule } from 'primeng/components/spinner/spinner';
import { ProgressSpinnerModule } from 'primeng/components/progressspinner/progressspinner';
import { TabViewModule } from 'primeng/components/tabview/tabview';
import { PickListModule } from 'primeng/components/picklist/picklist';
import { MessageModule } from 'primeng/components/message/message';
import { ToggleButtonModule } from 'primeng/components/togglebutton/togglebutton';
import { PaginatorModule } from 'primeng/components/paginator/paginator';
import { ProgressBarModule } from 'primeng/components/progressbar/progressbar';
import { SplitButtonModule } from 'primeng/components/splitbutton/splitbutton';
import { OverlayPanelModule } from 'primeng/components/overlaypanel/overlaypanel';
import { CarouselModule } from 'primeng/components/carousel/carousel';
import { InputSwitchModule } from 'primeng/components/inputswitch/inputswitch';
import { AutoCompleteModule } from 'primeng/components/autocomplete/autocomplete';
import { ColorPickerModule } from 'primeng/components/colorpicker/colorpicker';
@NgModule({
  imports: [CommonModule],
  providers: [ConfirmationService],
  exports: [
    NgxChartsModule,
    MatSidenavModule,
    MatCardModule,
    FormsModule,
    AccordionModule,
    DataGridModule,
    PanelModule,
    ButtonModule,
    TooltipModule,
    DropdownModule,
    MultiSelectModule,
    DataTableModule,
    CalendarModule,
    CheckboxModule,
    DialogModule,
    InputMaskModule,
    GrowlModule,
    ConfirmDialogModule,
    InputTextModule,
    SelectButtonModule,
    MessagesModule,
    SpinnerModule,
    ProgressSpinnerModule,
    TabViewModule,
    PickListModule,
    MessageModule,
    ToggleButtonModule,
    TableModule,
    PaginatorModule,
    ProgressBarModule,
    SplitButtonModule,
    OverlayPanelModule,
    CarouselModule,
    InputSwitchModule,
    AutoCompleteModule,
    ColorPickerModule,
  ],
})
export class SharedUiModule {}
